<template>
    <div>
        <input type="hidden" name="custom_area_json" v-model="customAreaJson">
        <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModal">
            {{ $t('custom_area.modal_btn') }}
        </button>

        <!-- Modal -->
        <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title" id="exampleModalLabel">{{ $t('custom_area.title') }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body pt-0">
                        <div v-for="(area, index) in customArea">
                            <div class="row border-bottom mt-4">
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <select class="custom-select w-100" v-model="area.type"
                                                @change="updateArea(index, 'type', $event.target.value)">
                                            <option v-for="type in types" :value="type">{{ $t('custom_area.types.' + type) }}</option>
                                        </select>
                                        <input class="form-control text-left mt-1" v-if="area.type == 'other'" type="text"
                                               :value="area.description"
                                               @input="updateArea(index, 'description', $event.target.value)">
                                    </div>
                                </div>

                                <div class="col-md-5">
                                    <div class="input-group">
                                        <input class="form-control border-radius-0-right" type="number" min="0.01" step="0.01"
                                               :value="area.value" @input="updateArea(index, 'value', $event.target.value)">
                                        <div class="input-group-append">
                                            <span class="input-group-text">m<sup>2</sup></span>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-2">
                                    <button type="button" class="btn btn-danger" @click="removeArea(index)">{{ $t('custom_area.remove') }}</button>
                                </div>
                            </div>
                        </div>
                        <button type="button" class="btn btn-secondary mt-4" @click="addNewArea">{{ $t('custom_area.add') }}</button>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="resetArea">{{ $t('custom_area.close') }}</button>
                        <button type="button" class="btn btn-primary" data-dismiss="modal" @click="saveArea">{{ $t('custom_area.save') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>

export default {
    name: 'form-custom-area',
    props: ['onSave'],

    data: function () {
        return {
            customArea: [],
            selectedType: '',
        }
    },

    methods: {
        addNewArea: function () {
            this.customArea.push({
                type: '',
                description: '',
                value: 0
            });
        },

        updateArea: function (index, field, value) {
            this.customArea[index][field] = value;
            this.$emit('update:customArea', this.customArea);
        },

        removeArea: function (index) {
            this.customArea.splice(index, 1);
            this.$emit('update:customArea', this.customArea);
        },

        resetArea: function () {
            this.customArea = [];
            this.$emit('update:customArea', this.customArea);
        },

        saveArea: function () {
            this.onSave(this.customArea.reduce((sum, area) => {
                if (Vue.Constants.IGNORED_TYPES.includes(area.type)) {
                    return parseFloat(parseFloat(sum).toFixed(2));
                }
                return parseFloat(parseFloat(parseFloat(sum) + parseFloat(area.value)).toFixed(2))
            }, 0))
        }
    },

    computed: {
        customAreaJson: function () {
            return JSON.stringify(this.customArea);
        },

        types: function () {
            let propertyType = this.$parent.$parent.getType();

            if (propertyType == 'flat') {
                return Vue.Constants.AREA_TYPES.concat(
                    Vue.Constants.AREA_FLAT_TYPES
                );
            }

            return Vue.Constants.AREA_TYPES.concat(
                Vue.Constants.AREA_HOUSE_TYPES
            );
        }
    },

    mounted: function () {
        if (this.$parent.$parent.oldData.custom_area_json) {
            try {
                this.customArea = JSON.parse(this.$parent.$parent.oldData.custom_area_json);
            } catch (e) {
                this.customArea = [];
            }
        } else {
            this.customArea = [];
        }
    }
}
</script>



<style scoped>

</style>
